<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-md-6">
        <div class="panel panel-default mtl">
          <div class="panel-body">
            <div class="form-group">
              <label for="topPickPreferences">
                {{ lang.get('score-set.form.top-pick-preferences.label') }}
              </label>
              <input
                id="topPickPreferences"
                type="number"
                class="form-control"
                name="topPickPreferences"
                :value="scoreSet.topPickPreferences"
                @input="
                  e =>
                    onInput({
                      topPickPreferences: parseInteger(e.target.value)
                    })
                "
                @blur="e => onBlur('topPickPreferences', e.target.value)"
              />
            </div>
            <advanced-toggle v-model="advanced" />
            <div v-show="advanced">
              <div class="form-group">
                <div
                  v-for="mode in ['categories', 'all']"
                  :key="'top-pick-mode-' + mode"
                  class="radio styled"
                >
                  <input
                    :id="'top-pick-mode-' + mode"
                    name="topPickMode"
                    type="radio"
                    :checked="scoreSet.topPickMode === mode"
                    :value="scoreSet.topPickMode"
                    @change="e => onInput({ topPickMode: mode })"
                  />
                  <label :for="'top-pick-mode-' + mode">
                    {{
                      stripTags(
                        lang.get('score-set.form.top-pick-mode.' + mode)
                      )
                    }}
                  </label>
                </div>
              </div>
              <div class="form-group">
                <label for="topPickWinners">
                  {{ lang.get('score-set.form.top-pick-winners.label') }}
                </label>
                <input
                  id="topPickWinners"
                  type="number"
                  class="form-control"
                  name="topPickWinners"
                  :value="scoreSet.topPickWinners"
                  @input="
                    e =>
                      onInput({
                        topPickWinners: parseInteger(e.target.value)
                      })
                  "
                  @blur="e => onBlur('topPickWinners', e.target.value)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <component-preview
          :heading="lang.get('judging.preview.heading')"
          class="mbx mtl"
        >
          <top-pick-preview :pills="scoreSet.topPickPreferences" />
        </component-preview>
      </div>
    </div>
    <navigation v-on="$listeners" />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { parseInteger } from '@/lib/utils';
import { stripTags } from '@/lib/string';
import ComponentPreview from '@/lib/components/ComponentPreview';
import Navigation from '../Navigation';
import AdvancedToggle from '../AdvancedToggle';
import TopPickPreview from '../Mode/TopPickPreview';

export default {
  inject: ['lang'],
  components: {
    Navigation,
    AdvancedToggle,
    ComponentPreview,
    TopPickPreview
  },
  data() {
    return {
      advanced: false
    };
  },
  computed: {
    ...mapGetters('judgingFastStart', ['scoreSet'])
  },
  methods: {
    ...mapMutations('judgingFastStart', ['setScoreSet']),
    onInput(input) {
      this.setScoreSet({ ...this.scoreSet, ...input });
    },
    onBlur(property, value) {
      // The minimum possible value is 1, it can't be blank
      if (parseInteger(value) < 1) {
        this.setScoreSet({ ...this.scoreSet, [property]: 1 });
      }
    },
    parseInteger,
    stripTags
  }
};
</script>
